/**
 * Copyright IBM Corp. 2022, 2026
 */

import React from 'react'
import s from './style.module.css'

function PlaceholderBox({
	prose,
	lines = [],
	repeat = 1,
	width,
	height,
	...props
}: {
	prose?: boolean
	lines?: string[]
	repeat?: number
} & React.CSSProperties) {
	if (prose)
		return (
			<p className={s.prose} aria-busy="true">
				{lines.map((lineWidth, index) => (
					<span
						// eslint-disable-next-line react/no-array-index-key
						key={index}
						className={s.box}
						style={{ width: lineWidth, height: '1rem', ...props }}
					/>
				))}
			</p>
		)

	return (
		<div aria-busy="true">
			{Array.from({ length: repeat }).map((el, index) => (
				<div
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					className={s.box}
					style={{ width, height, ...props }}
				/>
			))}
		</div>
	)
}

export default function Placeholder({
	children,
}: {
	children: (Box: typeof PlaceholderBox) => JSX.Element
	className?: string
}) {
	return <>{children(PlaceholderBox)}</>
}
